export default "__VITE_ASSET__CfkVHgLr__"